import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["deleteField"]
  static values = { escapiaChannelId: String }

  connect() {
    this.checkbox = this.element.querySelector(`input[type=checkbox][value="${this.escapiaChannelIdValue}"]`)
    if (!this.checkbox) return

    const anchor = this.checkbox.closest("label") || this.checkbox.parentElement
    anchor.insertAdjacentElement("afterend", this.deleteFieldTarget)
    this.sync()
  }

  onChange(event) {
    if (event.target === this.checkbox) this.sync()
  }

  sync() {
    const reveal = !this.checkbox.checked
    this.deleteFieldTarget.classList.toggle("hidden", !reveal)
    if (!reveal) this.deleteFieldTarget.querySelector("input[type=checkbox]").checked = false
  }
}
